module.exports = __webpack_public_path__ + "media/images/shark/Shark2-p-500-87cdc8f8483681d2990f871b3980eb2d.png";